import React, { useEffect } from 'react'
import { Box, Fab, Button, Grid, TextField, Typography, FormControl, Modal } from "@mui/material";
import { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import PoprchModal from "../payment/popSearch";
import { ToDate } from "../../common/toDate";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { addVendor,updateVendor } from "./vendorRegistrationApi.js"
import { addNewVendor, updateExistingVendor } from './vendorRegistrationCustomApiHandler.js';
import { swalAlertPopProps } from "../../utils/commonUtils";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import { ModalHeader } from '../../common/modalHeader.jsx';

function AddVendorForm({ open, setOpen, modalData, getVendorsList }) {

    const [formData, setFormData] = useState({});
    const [dateValue, setDateValue] = useState(dayjs())

    const struct = {
        id: 0,
        vendorId: "",
        vendorName: "",
        pan: "",
        gstRegistrationNumber: "",
        cinOrShopActNumber: "",
        companyAddress: "",
        phoneNumber: "",
        mobileNumber: "",
        alternateMobileNumber: "",
        bankAccountNumber: "",
        bankName: "",
        ifscCode: "",
        branchAddress: "",
        area: "",
        city: "",
        vendorInfoInShort: "",
        vendorRegistrationDate: "",
        emailId: "",
        emailId1: "",
        emailId2: "",
        upiId: ""
    }

    useEffect(() => {
        setFormData({ ...struct })
    }, [])

    const handleSubmit = async () => {
        if (!modalData?.id) {
            await addNewVendor(addVendor, formData, (res) => {
                if (res?.data?.succeeded) {
                    Swal.fire({
                        title: "Vendor Added Successfully",
                        icon: "success",

                        ...swalAlertPopProps,
                    });
                }
                else {
                    Swal.fire({
                        title: res?.data?.message,
                        icon: "error",

                        ...swalAlertPopProps,
                    });
                }
                setFormData({ ...struct })
            })
        } else {
            await updateExistingVendor(updateVendor, formData, (res)=>{
                if (res?.data?.succeeded) {
                    Swal.fire({
                        title: "Vendor Updated Successfully",
                        icon: "success",

                        ...swalAlertPopProps,
                    });
                }
                else {
                    Swal.fire({
                        title: res?.data?.message,
                        icon: "error",

                        ...swalAlertPopProps,
                    });
                }
                setFormData({ ...struct })
            })
        }

        getVendorsList()
        setOpen(false)
    }

    const onClose = () => {
        setFormData({ ...struct })
        setOpen(false)
    }

    useEffect(() => {
        if (open === true && modalData?.id) {
            // const date = dayjs(modalData?.vendorRegistrationDate).tz("UTC").format("YYYY-MM-DDTHH:mm:ss");

            setFormData({
                ...modalData,
                vendorRegistrationDate: dayjs(modalData.vendorRegistrationDate)
            })
        }
    }, [open])

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box
                sx={{
                    background: "white",
                    width: "52%",
                    overflowY: "auto",
                    // height: "90vh",
                    position: "absolute",
                    left: "25%",
                    top: "10%",
                    height: "80vh",
                }}
            >
                <ModalHeader title={"Vendor Registration"}
                    onClose={(data) => {
                        setFormData({ ...struct })
                        setOpen(data)
                    }}
                />
                <Grid container sx={{ position: "relative" }}>
                    <Grid container item xs={12}>
                        <Grid item xs={6} sx={{ p: "14px" }}>
                            <FormControl fullWidth >
                                <TextField
                                    label="Vendor Id"
                                    name="vendorId"

                                    value={formData.vendorId}
                                    onChange={(e) => {
                                        setFormData({ ...formData, vendorId: Number(e.target.value) });
                                    }}
                                    onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
                                    }}
                                    required
                                    InputLabelProps={{ className: "mulish" }}
                                    InputProps={{ classes: { input: "mulish" } }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} sx={{ p: "14px" }}>
                            <FormControl fullWidth >
                                <TextField
                                    label="Vendor Name"
                                    name="vendorName"

                                    value={formData.vendorName}
                                    onChange={(e) => {
                                        setFormData({ ...formData, vendorName: e.target.value });
                                    }}
                                    onInput={(e) => {
                                        e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);
                                    }}
                                    required
                                    InputLabelProps={{ className: "mulish" }}
                                    InputProps={{ classes: { input: "mulish" } }}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container item xs={12}>
                        <Grid item xs={4} sx={{ p: "14px" }}>
                            <FormControl fullWidth >
                                <TextField
                                    label="PAN Number"
                                    name="pan"

                                    value={formData.pan}
                                    onChange={(e) => {
                                        setFormData({ ...formData, pan: e.target.value });
                                    }}

                                    onInput={(e) => {
                                        let value = e.target.value.toUpperCase();
                                        const regex = /^[A-Z]{0,5}[0-9]{0,4}[A-Z]{0,1}$/; // Allow partial input
                                        if (!regex.test(value)) {
                                            e.target.value = value.slice(0, -1); // Remove the last character if invalid
                                        } else {
                                            e.target.value = value; // Keep the valid input
                                        }
                                    }}
                                    InputLabelProps={{ className: "mulish" }}
                                    InputProps={{ classes: { input: "mulish" } }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={4} sx={{ p: "14px" }}>
                            <FormControl fullWidth >
                                <TextField
                                    label="GST Registration Number"
                                    name="gstRegistrationNumber"

                                    value={formData.gstRegistrationNumber}
                                    onChange={(e) => {
                                        setFormData({ ...formData, gstRegistrationNumber: e.target.value });
                                    }}
                                    onInput={(e) => {
                                        let value = e.target.value.toUpperCase();
                                        const regex = /^[0-9]{0,2}[A-Z]{0,5}[0-9]{0,4}[A-Z]{0,1}[1-9A-Z]{0,1}[Z]{0,1}[0-9A-Z]{0,1}$/;
                                        if (!regex.test(value)) {
                                            e.target.value = value.slice(0, -1);
                                        } else {
                                            e.target.value = value;
                                        }
                                    }}
                                    InputLabelProps={{ className: "mulish" }}
                                    InputProps={{ classes: { input: "mulish" } }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={4} sx={{ p: "14px" }}>
                            <FormControl fullWidth >
                                <TextField
                                    label="CIN / Shop ACT Number"
                                    name="cinOrShopActNumber"

                                    value={formData.cinOrShopActNumber}
                                    onChange={(e) => {
                                        setFormData({ ...formData, cinOrShopActNumber: e.target.value });
                                    }}
                                    InputLabelProps={{ className: "mulish" }}
                                    InputProps={{ classes: { input: "mulish" } }}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sx={{ p: "14px" }}>
                        <FormControl fullWidth >
                            <TextField
                                label="Company Address"
                                name="companyAddress"

                                value={formData.companyAddress}
                                onChange={(e) => {
                                    setFormData({ ...formData, companyAddress: e.target.value });
                                }}
                                onInput={(e) => {
                                    e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);
                                }}
                                InputLabelProps={{ className: "mulish" }}
                                InputProps={{ classes: { input: "mulish" } }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} sx={{ p: "14px" }}>
                        <FormControl fullWidth >
                            <TextField
                                label="Phone Number"
                                name="phoneNumber"

                                value={formData.phoneNumber}
                                onChange={(e) => {
                                    setFormData({ ...formData, phoneNumber: e.target.value });
                                }}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
                                }}
                                InputLabelProps={{ className: "mulish" }}
                                InputProps={{ classes: { input: "mulish" } }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} sx={{ p: "14px" }}>
                        <FormControl fullWidth >
                            <TextField
                                label="Mobile Number"
                                name="mobileNumber"

                                value={formData.mobileNumber}
                                onChange={(e) => {
                                    setFormData({ ...formData, mobileNumber: e.target.value });
                                }}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
                                }}
                                InputLabelProps={{ className: "mulish" }}
                                InputProps={{ classes: { input: "mulish" } }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} sx={{ p: "14px" }}>
                        <FormControl fullWidth >
                            <TextField
                                label="Alternate Mobile Number"
                                name="alternateMobileNumber"

                                value={formData.alternateMobileNumber}
                                onChange={(e) => {
                                    setFormData({ ...formData, alternateMobileNumber: e.target.value });
                                }}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
                                }}
                                InputLabelProps={{ className: "mulish" }}
                                InputProps={{ classes: { input: "mulish" } }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} sx={{ p: "14px" }}>
                        <FormControl fullWidth >
                            <TextField
                                label="Bank Account Number"
                                name="bankAccountNumber"

                                value={formData.bankAccountNumber}
                                onChange={(e) => {
                                    setFormData({ ...formData, bankAccountNumber: e.target.value });
                                }}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                }}
                                InputLabelProps={{ className: "mulish" }}
                                InputProps={{ classes: { input: "mulish" } }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} sx={{ p: "14px" }}>
                        <FormControl fullWidth >
                            <TextField
                                label="Bank Name"
                                name="bankName"

                                value={formData.bankName}
                                onChange={(e) => {
                                    setFormData({ ...formData, bankName: e.target.value });
                                }}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/\b\w/g, (char) => char.toUpperCase());
                                }}
                                InputLabelProps={{ className: "mulish" }}
                                InputProps={{ classes: { input: "mulish" } }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} sx={{ p: "14px" }}>
                        <FormControl fullWidth >
                            <TextField
                                label="IFSC Code"
                                name="ifscCode"

                                value={formData.ifscCode}
                                onChange={(e) => {
                                    setFormData({ ...formData, ifscCode: e.target.value });
                                }}
                                onInput={(e) => {
                                    e.target.value = e.target.value.toUpperCase();
                                }}
                                InputLabelProps={{ className: "mulish" }}
                                InputProps={{ classes: { input: "mulish" } }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} sx={{ p: "14px" }}>
                        <FormControl fullWidth >
                            <TextField
                                label="Branch Address"
                                name="branchAddress"

                                value={formData.branchAddress}
                                onChange={(e) => {
                                    setFormData({ ...formData, branchAddress: e.target.value });
                                }}
                                onInput={(e) => {
                                    e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);
                                }}
                                InputLabelProps={{ className: "mulish" }}
                                InputProps={{ classes: { input: "mulish" } }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} sx={{ p: "14px" }}>
                        <FormControl fullWidth >
                            <TextField
                                label="Area"
                                name="area"

                                value={formData.area}
                                onChange={(e) => {
                                    setFormData({ ...formData, area: e.target.value });
                                }}
                                onInput={(e) => {
                                    e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);
                                }}
                                InputLabelProps={{ className: "mulish" }}
                                InputProps={{ classes: { input: "mulish" } }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} sx={{ p: "14px" }}>
                        <FormControl fullWidth >
                            <TextField
                                label="City"
                                name="city"
                                value={formData.city}
                                onChange={(e) => {
                                    setFormData({ ...formData, city: e.target.value });
                                }}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/\b\w/g, (char) => char.toUpperCase());
                                }}
                                InputLabelProps={{ className: "mulish" }}
                                InputProps={{ classes: { input: "mulish" } }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sx={{ p: "14px" }}>
                        <FormControl fullWidth >
                            <TextField
                                label="Vendor Info In Short"
                                name="vendorInfoInShort"

                                value={formData.vendorInfoInShort}
                                onChange={(e) => {
                                    setFormData({ ...formData, vendorInfoInShort: e.target.value });
                                }}
                                InputLabelProps={{ className: "mulish" }}
                                InputProps={{ classes: { input: "mulish" } }}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={4} sx={{ p: "14px" }}>
                        <FormControl fullWidth >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Vendor Registration Date"
                                    value={formData.vendorRegistrationDate ? dayjs(formData.vendorRegistrationDate) : null}
                                    onChange={(newValue) => {
                                        console.log(newValue)
                                        // let formattedDate = dayjs(newValue).format("YYYY-MM-DD");
                                        setFormData({ ...formData, vendorRegistrationDate: newValue });
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            fullWidth
                                            InputLabelProps={{ className: "mulish" }}
                                            InputProps={{ classes: { input: "mulish" } }}
                                        />
                                    )}
                                />
                            </LocalizationProvider>
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} sx={{ p: "14px" }}>
                        <FormControl fullWidth >
                            <TextField
                                label="Email 1"
                                name="emailId"

                                value={formData.emailId}
                                onChange={(e) => {
                                    setFormData({ ...formData, emailId: e.target.value });
                                }}
                                InputLabelProps={{ className: "mulish" }}
                                InputProps={{ classes: { input: "mulish" } }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} sx={{ p: "14px" }}>
                        <FormControl fullWidth >
                            <TextField
                                label="Email 2"
                                name="emailId1"

                                value={formData.emailId1}
                                onChange={(e) => {
                                    setFormData({ ...formData, emailId1: e.target.value });
                                }}
                                InputLabelProps={{ className: "mulish" }}
                                InputProps={{ classes: { input: "mulish" } }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} sx={{ p: "14px" }}>
                        <FormControl fullWidth >
                            <TextField
                                label="Email 3"
                                name="emailId2"

                                value={formData.emailId2}
                                onChange={(e) => {
                                    setFormData({ ...formData, emailId2: e.target.value });
                                }}
                                InputLabelProps={{ className: "mulish" }}
                                InputProps={{ classes: { input: "mulish" } }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} sx={{ p: "14px" }}>
                        <FormControl fullWidth >
                            <TextField
                                label="UPI Id"
                                name="upiId"

                                value={formData.upiId}
                                onChange={(e) => {
                                    setFormData({ ...formData, upiId: e.target.value });
                                }}
                                InputLabelProps={{ className: "mulish" }}
                                InputProps={{ classes: { input: "mulish" } }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sx={{ p: "14px" }}>
                        <Button
                            onClick={handleSubmit}
                            sx={{ width: "100%" }} variant="contained"
                        >
                            {modalData?.id ? "Update" : "Add"}
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </Modal>
    )
}

export default AddVendorForm
